import {
  oneOfType,
  string,
  bool,
  number,
  node,
  shape,
  arrayOf,
} from "prop-types";

export const ensemblTranscriptsType = arrayOf(
  shape({
    items: arrayOf(
      shape({
        name: string,
        strand: string,
        coding_impact: node,
        function: arrayOf(string),
        hgvs: string,
        hgvs_p1: node,
        hgvs_p3: node,
        location: string,
        coding_location: node,
        canonical: bool,
        gene_symbol: string,
        splice_distance: string,
        ensembl_support_level: oneOfType([string, number]),
      })
    ),
    version: string,
  })
);

export const transcriptsType = arrayOf(
  shape({
    name: string,
    strand: string,
    chromo: string,
    position: number,
    length: number,
    mrna_length: number,
    coding_length: number,
    canonical: bool,
    cytoband: string,
    ensembl_support_level: oneOfType([string, number]),
  })
);

export const refGenomeType = shape({
  id: oneOfType([string, number]),
  name: string,
  description: string,
  default: bool,
});

export const proteinViewerDataType = shape({
  results: arrayOf(shape({})),
  error: bool,
  isOpenThroughCards: bool,
  finalTranscripts: arrayOf(
    shape({
      canonical: bool,
      coding_impact: string,
      coding_location: string,
      ensembl_support_level: oneOfType([string, number]),
      function: arrayOf(string),
      gene_symbol: string,
      hgvs: string,
      hgvs_p1: string,
      hgvs_p3: string,
      location: string,
      name: string,
      splice_distance: string,
      strand: string,
    })
  ),
});
